import InnerTopBar from './component';

export default InnerTopBar;
